import axios from 'axios';

export async function search(
  filters: Record<string, unknown>
): Promise<App.Configuration.Data.SchoolData[]> {
  return axios.get(route('api.schools.search', filters)).then((res) => res.data);
}
